import { motion } from "framer-motion";
import { FileDown } from "lucide-react";
import { LAB_REPORTS } from "../config";

export const Quality = () => (
  <section id="quality" data-testid="quality-section" className="relative bg-ink grain py-28 md:py-36 overflow-hidden">
    <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-12 gap-12 items-center">
      <div className="md:col-span-7">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-xs tracking-[0.4em] uppercase text-gold mb-4"
        >
          Quality & Testing
        </motion.p>
        <div className="overflow-hidden mb-8">
          <motion.h2
            initial={{ y: "100%" }}
            whileInView={{ y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="font-serif text-4xl md:text-6xl text-cream tracking-tighter"
          >
            Tested. Published. <span className="italic text-gold">Yours to check.</span>
          </motion.h2>
        </div>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="max-w-xl text-base font-light text-cream/65 leading-relaxed"
        >
          Every PhudG oil is independently lab-tested — and we don't ask you to
          trust us, we show you. Download the actual lab reports and read
          exactly what's in the bottle.
        </motion.p>
      </div>
      <div className="md:col-span-5">
        <div className="rounded-3xl border border-white/10 bg-white/[0.03] backdrop-blur-sm divide-y divide-white/10">
          {LAB_REPORTS.map((r, i) => (
            <motion.a
              key={r.url}
              data-testid={r.testid}
              href={r.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="group flex items-center justify-between px-6 py-5 hover:bg-white/5 transition-colors duration-300"
            >
              <span className="text-sm font-light text-cream/70 group-hover:text-cream transition-colors duration-300">
                {r.name} — Lab Report
              </span>
              <span className="flex items-center gap-2 text-[10px] tracking-[0.25em] uppercase text-gold">
                <FileDown size={15} /> PDF
              </span>
            </motion.a>
          ))}
        </div>
      </div>
    </div>
  </section>
);
